import React, { useState } from "react";
import { IonContent, IonRow, IonCard, IonCardHeader, IonCardTitle, IonCardContent, IonCol, IonSelect, IonSelectOption, IonButton, useIonAlert } from "@ionic/react";
import { userInput } from "../../store/atoms/userDetailAtom";
import { useRecoilState, } from "recoil";
import { handleUserDetailsUpdate, handleUserSignUp } from "./handler"
import { useHistory } from 'react-router-dom';

const SignUp = () => {
  const [userInputState, setUserInputState] = useRecoilState(userInput);
  const history = useHistory()
  const [present] = useIonAlert()

  const [userDetails, setUserDetails] = useState({
        firstName :"",
        email: "",
        gender: null,
        mobileNumber: "" ,
        otp: "",
    })
  
  return (
    <>
      <IonContent>
        <IonRow className="image-bg">
          <IonCard>
            <IonCardHeader>
              <img src="img/logo.png" className="logo-img"></img>
              <IonCardTitle>
                <h1>Get Started</h1>
              </IonCardTitle>
              <p>Sign up as a business to enjoy full RydeSEND features</p>
            </IonCardHeader>
            <IonCardContent>
              <div className="custom-label">
                <IonCol>
                  <ion-label>Full Name</ion-label>
                  <input
                    type="text"
                    className="custom-input"
                    placeholder=""
                    onChange={(e)=>{handleUserDetailsUpdate('firstName', e.target.value, setUserDetails, setUserInputState)}}
                  />
                </IonCol>
                <IonCol>
                  <ion-label>Email</ion-label>
                  <input
                    type="text"
                    className="custom-input"
                    placeholder=""
                    value={userInputState.email}
                    onChange={(e)=>{handleUserDetailsUpdate('email', e.target.value, setUserDetails, setUserInputState)}}
                  />
                </IonCol>
                <IonCol className="contact">
                  <ion-label>Gender</ion-label>
                  <IonSelect
                    placeholder="Select"
                    onSelect={(e)=>{handleUserDetailsUpdate('gender', e.target.value, setUserDetails)}}
                  >
                    <IonSelectOption value="0">Male</IonSelectOption>
                    <IonSelectOption value="1">Female</IonSelectOption>
                    <IonSelectOption value="2">
                      Prefer not to specify
                    </IonSelectOption>
                  </IonSelect>
                </IonCol>

                <div className="contact">
                  <IonCol className="contact">
                    <ion-label>Contact Number</ion-label>
                    <input
                      type="number"
                      className="custom-input"
                      style={{ textAlign: "left" }}
                      value={userInputState.mobileNumber}
                      onChange={(e)=>{handleUserDetailsUpdate('mobileNumber', e.target.value, setUserDetails, setUserInputState)}}
                    />
                    { (userInputState.userSelectedInput === "email" || userInputState.mobileOtp === "" ) &&
                    <div>
                      <button
                        className="floating-end-slot"
                      >
                        Request OTP
                      </button>
                    </div>
                    }


                  </IonCol>
                </div>
                { (userInputState.userSelectedInput === "email" || userInputState.mobileOtp === "" ) &&
                  <IonCol>
                    <ion-label>OTP</ion-label>
                    <input
                      type="text"
                      className="custom-input"
                      placeholder=""
                      max="6"
                      onChange={(e)=>{handleUserDetailsUpdate('otp', e.target.value, setUserDetails)}}
                    />
                  </IonCol>
                }
                <p>
                  By signing up you agree to RYDE Technologies{" "}
                  <a className="sub-link">Terms </a>and{" "}
                  <a className="sub-link">Privacy Policy.</a>
                </p>

                <IonButton
                  color="primary"
                  size="large"
                  expand="block"
                  mode="ios"
                  onClick={async ()=>{let res = await handleUserSignUp(userDetails, userInputState, setUserInputState, history);
                  if (!res.status) {
                    present({
                        message: res.error.msg,
                        buttons: [
                                'Ok'
                        ],
                    })
                  }
                }}
                >
                  Sign up
                </IonButton>
                <a  className="link-btn" onClick={()=>{
                    setUserInputState({
                        userSelectedInput : "mobileNumber",
                        mobileNumber : "" ,
                        email : "" ,
                        newUser: false,
                        mobileOtp: "",
                    })
                    history.push("/new/login")
                }}>
                  Login
                </a>
              </div>
            </IonCardContent>
          </IonCard>
        </IonRow>
      </IonContent>
    </>
  );
};

export default SignUp;
